import { TEXT_ALIGN_OPTIONS } from "./editorFieldUtils";

const alignToFlex = (align) => {
  if (align === "center") {
    return "center";
  }
  if (align === "right") {
    return "flex-end";
  }
  return "flex-start";
};

export const DEFAULT_LAYOUT_MARGINS = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

/** Canvas / CSS margin shorthand for layout blocks. */
export const layoutMarginsCss = (props) => {
  const margins = { ...DEFAULT_LAYOUT_MARGINS, ...(props?.margins || {}) };
  const { top, right, bottom, left } = margins;
  if (!top && !right && !bottom && !left) {
    return "";
  }
  return `margin:${top}px ${right}px ${bottom}px ${left}px;`;
};

/**
 * Email-safe spacing: margins become padding on the outer wrapper td
 * (margin on table cells is ignored by most email clients).
 */
export const layoutMarginsPaddingCss = (props) => {
  const margins = { ...DEFAULT_LAYOUT_MARGINS, ...(props?.margins || {}) };
  const { top, right, bottom, left } = margins;
  if (!top && !right && !bottom && !left) {
    return "";
  }
  return `padding:${top}px ${right}px ${bottom}px ${left}px;`;
};

export const layoutGridWidthPercent = (props) => props?.widthPercent ?? 100;

export const layoutAlignToTd = (align) => {
  const match = TEXT_ALIGN_OPTIONS.find((option) => option.value === align);
  if (match?.value === "center") {
    return "center";
  }
  if (match?.value === "right") {
    return "right";
  }
  return "left";
};

/** Styles for the alignment td inside the email wrapper. */
export const layoutAlignTdCss = (props) => {
  const align = layoutAlignToTd(props?.contentAlign || "left");
  return `text-align:${align};vertical-align:top;`;
};

/**
 * Email-safe outer shell: margins as padding + horizontal alignment for the layout inner block.
 * The visible layout box (background, border, width) lives in wcp-layout-inner.
 */
export const wrapLayoutBlockHtml = (layoutInnerHtml, props) => {
  const align = layoutAlignToTd(props?.contentAlign || "left");
  const paddingCss = layoutMarginsPaddingCss(props);
  const outerTdStyle = paddingCss ? ` style="${paddingCss.replace(/"/g, "&quot;")}"` : "";
  const alignTdStyle = ` style="${layoutAlignTdCss(props).replace(/"/g, "&quot;")}"`;

  return `<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt;"><tr><td${outerTdStyle}><table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;border-collapse:collapse;"><tr><td align="${align}"${alignTdStyle}>${layoutInnerHtml}</td></tr></table></td></tr></table>`;
};

/** Canvas outer shell: margins + horizontal alignment (width lives on inner layout box). */
export const layoutBlockOuterSx = (props) => {
  const margins = { ...DEFAULT_LAYOUT_MARGINS, ...(props?.margins || {}) };
  return {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignSelf: alignToFlex(props?.contentAlign || "left"),
    marginTop: `${margins.top}px`,
    marginRight: `${margins.right}px`,
    marginBottom: `${margins.bottom}px`,
    marginLeft: `${margins.left}px`,
    boxSizing: "border-box",
  };
};

 